// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_ub9","cls2":"FriendlySutdModal-cls2_hDr FriendlySutdModal-cls1_ub9","active":"FriendlySutdModal-active_mHB"};